<div class="mat-stf-accordion mat-stf-accordion_second">
  <ng-content></ng-content>
</div>
